import frTranslationMessages from 'translations/fr.json';
import arTranslationMessages from 'translations/ar.json';
import { DEFAULT_LOCALE } from 'store/LanguageProvider/constants';

export const formatTranslationMessages = (
  locale: string,
  messages: Messages,
): Messages => {
  const defaultFormattedMessages: Messages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, frTranslationMessages)
      : {};

  return Object.keys(messages).reduce(
    (formattedMessages: Messages, key: string) => {
      let message: string = messages[key];
      if (!message && locale !== DEFAULT_LOCALE) {
        message = defaultFormattedMessages[key];
      }
      return Object.assign(formattedMessages, { [key]: message });
    },
    {},
  );
};

export const translationMessages = {
  fr: formatTranslationMessages('fr', frTranslationMessages),
  ar: formatTranslationMessages('ar', arTranslationMessages),
};
